const config = [
	{
		url: window.REACT_HELP_TC_URL || process.env.REACT_HELP_TC_URL,
		name: "Personal Cloud",
		domain: "Personal Tech"
    },
	{
		url: window.REACT_HELP_PERSONAL_URL || process.env.REACT_HELP_PERSONAL_URL,
        name: "Personal Cloud",
        domain: "Personal Empresas"
    },
]

export default config
